var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGradientCalendar = function SvgGradientCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3751_59978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C8.08929 0 8.57143 0.461742 8.57143 1.03125V4.125H21.4286V1.03125C21.4286 0.461742 21.9107 0 22.5 0C23.0893 0 23.5714 0.461742 23.5714 1.03125V4.125H25.7143C28.0781 4.125 30 5.97158 30 8.25V28.875C30 31.1502 28.0781 33 25.7143 33H4.28571C1.91853 33 0 31.1502 0 28.875V8.25C0 5.97158 1.91853 4.125 4.28571 4.125H6.42857V1.03125C6.42857 0.461742 6.91071 0 7.5 0ZM27.8571 12.375H20.8929V17.0156H27.8571V12.375ZM27.8571 19.0781H20.8929V24.2344H27.8571V19.0781ZM27.8571 26.2969H20.8929V30.9375H25.7143C26.8996 30.9375 27.8571 30.0158 27.8571 28.875V26.2969ZM18.75 24.2344V19.0781H11.25V24.2344H18.75ZM11.25 30.9375H18.75V26.2969H11.25V30.9375ZM9.10714 24.2344V19.0781H2.14286V24.2344H9.10714ZM2.14286 26.2969V28.875C2.14286 30.0158 3.10246 30.9375 4.28571 30.9375H9.10714V26.2969H2.14286ZM2.14286 17.0156H9.10714V12.375H2.14286V17.0156ZM11.25 17.0156H18.75V12.375H11.25V17.0156ZM25.7143 6.1875H4.28571C3.10246 6.1875 2.14286 7.10918 2.14286 8.25V10.3125H27.8571V8.25C27.8571 7.10918 26.8996 6.1875 25.7143 6.1875Z",
    fill: "url(#paint0_linear_3751_59978)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3751_59978",
    x1: 30.5625,
    y1: 23.925,
    x2: 2.70015,
    y2: 5.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B2FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3751_59978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 33,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGradientCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gradient-calendar.2e867065d76de84ae194c2bd0a048b9e.svg";